module.exports = __webpack_public_path__ + "static/media/approve-proj-req.7bf7ad3d.svg";